import PropTypes from 'prop-types'

export default PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isManualTriggering: PropTypes.bool.isRequired,
  isRunning: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired,
  variations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    weight: PropTypes.number.isRequired
  })).isRequired,
  urlConditions: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })),
  allowOnlyOrganicTraffic: PropTypes.bool,
  allowOnlyUTMTraffic: PropTypes.bool,
  disabledDefaultVariationId: PropTypes.number,
  gaCustomDimension: PropTypes.number
}))
